import {
  FieldGroupId,
  FieldSegmentType,
  FieldStatus,
  FieldType,
} from 'common/fields/entities/enums'
import { FilterOperator } from 'common/filter/filterConstants'
import { WEEKDAYS } from 'constants/constants'

import {
  FieldTypeDefaultOperator,
  FieldTypeOperator,
  FilterField,
} from './models/AudienceFilter/constants'

export interface IField {
  folder_id: number
  caption: string
  description: string | null
  name: string
  segment_type: FieldSegmentType
  type: FieldType
}

export interface ConditionField {
  name: string
  segment_type: FieldSegmentType
  type: FieldType
}

export interface IFilterFields {
  custom: IField[] | null
  error: string | null
  fetching: boolean
  global: IField[] | null
  requestId: number | null
  static: IField[] | null
  system: IField[] | null
  integration: Record<string, IField[]> | null
}

export interface FilterValues {
  items?: FilterValueItem[]
  query?: string
  fetching?: boolean
}

export interface FilterValueItem {
  value: number
  label: string
  type: FieldSegmentType
  folder_id: number
  count?: number
  field?: FieldType
  segment_id?: string
  active?: boolean
}

export interface IFilterState {
  fields: IFilterFields
  values: FilterValues
}

export type FilterConditionOperator = FieldTypeDefaultOperator | FieldTypeOperator

export interface FilterCondition extends Omit<IFilterGroupItem, 'value'> {
  _oid?: string
  case_sensitive?: boolean
  is_formula?: boolean
  value?: string | number | null | BetweenDatesConditionValue
  offset?: { operator: string; value: number } | null
  item?: string
}

export interface IFilterGroupItem {
  type: FieldType | FieldSegmentType | FilterField
  field: string
  operator?: FilterConditionOperator
  value?: string | number
}

export interface IFilterGroup<T extends IFilterGroupItem | FilterCondition = IFilterGroupItem> {
  operator: FilterOperator
  items: T[]
}

export interface IFilter<T extends IFilterGroupItem | FilterCondition = IFilterGroupItem> {
  operator: FilterOperator
  groups: Array<IFilterGroup<T>>
}

export enum FilterScenario {
  CONDITION_NODE = 'condition_node',
  LIVECHAT = 'livechat',
  AUTO_ASSIGN = 'auto_assign',
  IMPORT_CONTACTS = 'import_contacts',
  EXTERNAL_REQUESTS = 'external_requests',
  GOOGLE_SHEETS = 'google_sheets',
  CONTACTS = 'contacts',
}

export enum ConditionValueOperator {
  IS = 'IS',
  IS_NOT = 'IS_NOT',
}

export interface ConditionTagFieldDescription {
  id: string
  group: FieldGroupId
  segmentType: FieldSegmentType
  status: FieldStatus
  type: FieldType
}

export interface ConditionTagPickerCondition {
  field: FieldType
  operator: ConditionValueOperator
  type: FieldSegmentType
  value: number
}

export interface FilterError {
  prop: string
  message: string
}

export interface BetweenDatesConditionTime {
  time: string
}

export interface BetweenDatesConditionValue {
  from: BetweenDatesConditionTime
  to: BetweenDatesConditionTime
  weekdays: Array<typeof WEEKDAYS[number]>
  time_zone?: string
}

export interface DefaultConditionData {
  value: BetweenDatesConditionValue | null
  offset: null
}

export interface FilterFieldOperatorData {
  value: FieldTypeOperator
  label: string
  display: string
  ignoreValue?: boolean
  changedLabel?: string | null
  translatedChangedLabel?: (() => string) | null
  translatedLabel?: () => string
}
